function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u8CBC\\u4E0A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.000000, 3.000000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.98758222,0.928979888 L2.98758222,2.92897989 L1,2.92897989 L1,12.9289799 L6.00295737,12.9289799 L6.00295737,14.9289799 L1,14.9289799 C-0.0543617951,14.9289799 -0.918165122,14.1131021 -0.994514264,13.0782422 L-1,12.9289799 L-1,2.92897989 C-1,1.87461809 -0.184122209,1.01081477 0.850737655,0.934465624 L1,0.928979888 L2.98758222,0.928979888 Z M11,0.928979888 C12.0543618,0.928979888 12.9181651,1.74485768 12.9945143,2.77971754 L13,2.92897989 L13,8.12159756 L11,8.12159756 L11,2.92897989 L9.01361259,2.92897989 L9.01361259,0.928979888 L11,0.928979888 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,7.92897989 L8,7.92897989 C6.8954305,7.92897989 6,8.82441039 6,9.92897989 L6,16.9289799 C6,18.0335494 6.8954305,18.9289799 8,18.9289799 L15,18.9289799 C16.1045695,18.9289799 17,18.0335494 17,16.9289799 L17,9.92897989 C17,8.82441039 16.1045695,7.92897989 15,7.92897989 Z M8,9.92897989 L15,9.92897989 L15,16.9289799 L8,16.9289799 L8,9.92897989 Z",
  id: "Rectangle-Copy"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.83822217,-0.997164824 C4.61390831,-0.947437129 3.57774647,-0.248419103 3.17656145,0.870750285 L3.157,0.928 L2,0.928979888 L2,6.79181826 L10,6.79181826 L10,0.928979888 L8.843,0.928 L8.83112009,0.890802979 C8.41396406,-0.265926084 7.30257638,-0.98671981 6.01435585,-0.999827097 L5.83822217,-0.997164824 Z M5.99400745,1.00006939 C6.60193187,1.00625485 7.00702267,1.35443521 7.00702267,1.92897989 L7.00702267,2.92897989 L8,2.928 L8,4.791 L4,4.791 L4,2.928 L4.99722297,2.92897989 L4.99861273,1.93037158 C4.99945357,1.32618166 5.389572,0.993919422 5.99400745,1.00006939 Z",
  id: "Path-2"
})));

function SvgPaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CBC\u4E0A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.04a9d399.svg";
export { ForwardRef as ReactComponent };